// const productTile = require('site/product/productTile');
require('base/components/spinner');

/*
function filterProducts(endpoint) {
    $.spinner().start();

    $.ajax({
        url: endpoint,
    }).done((data) => {
        $('.category__products').html(data);
        productTile.init();
    }).fail(() => false)
        .always(() => $.spinner().stop());
}
*/

function changeCategoryItem(href) {
    document.location.href = href;
}

function changeCategorySelect(category) {
    $(`.refinements__select option[data-cgid="${category}"]`).prop('selected', 'selected');
}

function handleClickOnCategory(e) {
    const $target = $(e.currentTarget);

    changeCategorySelect($target.data('cgid'));
    changeCategoryItem($target.data('href-full'));
}

function handleSelectChange(e) {
    const $option = $(e.currentTarget).find('option:selected');

    changeCategoryItem($option.data('href-full'));
}

module.exports = {
    bindEvents: () => {
        $('.refinements__list-link').on('click.changecategory', handleClickOnCategory);
        $('.js-refinements-select').on('change.changecategory', handleSelectChange);
    },
};
